module.exports = __webpack_public_path__ + "img/wx-icon.5854b59f.png";